import { render, staticRenderFns } from "./TabsManager.vue?vue&type=template&id=e579e31e&scoped=true&"
import script from "./TabsManager.vue?vue&type=script&lang=js&"
export * from "./TabsManager.vue?vue&type=script&lang=js&"
import style0 from "./TabsManager.vue?vue&type=style&index=0&id=e579e31e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e579e31e",
  null
  
)

export default component.exports